exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tabs-body .button[data-v-86bdbeba]{margin:0 calc(.35714vw + 6.85714px) calc(.35714vw + 6.85714px) 0}", ""]);
